import ajax from 'axios'
// import axios from 'axios';
// import { getStorages } from '@/Utils/localStorage'
import store from '@/store'
import { setToken, setTokenG, setEquipmentNo, removeToken, removeEquipmentNo } from '@/utils/cookie'
import Vue from 'vue';
import { Toast } from 'vant';
import { mapActions, mapGetters } from 'vuex';
import Encode from "@/utils/ai_studio_code";
Vue.use(Toast);

const axios = ajax.create({
  // baseURL: process.env.NODE_ENV === "production" ? "http://api.inclusivekredit.com:20222" : "/", // 测试环境
  // baseURL: 'http://218.75.109.186:22222', //
  // baseURL: '/api', //
  baseURL: '/api',
  // baseURL: 'https://gkdlo.money-plus-app.in/',
  //https://gkdlo.money-plus-app.in/
  timeout: 30000,//
  withCredentials: true,
  store: store,
  headers: {}
})

// async function init() {
//   await this.list1();
//   this.list2();
// },

//
axios.interceptors.request.use(
  async function (config) {
    const store = config.store;
    console.log('store', config);

    if (store) {
      if (!store.getters.getFlutterBaseInfo.token) {
        await store.dispatch('fetchFlutterBaseInfo');
      }

      const flutterBaseInfo = store.getters.getFlutterBaseInfo;
      console.log('flutterBaseInfo', flutterBaseInfo, config);

      if (flutterBaseInfo) {

        config.data = { ...flutterBaseInfo, ...config.data };
        const token = flutterBaseInfo.token;
        console.log(config.headers, '2222222')
        if (config.url === '/g8jojer5kttuux4qgytZxHpjlXa' || config.url === '/g8qeeQ4pvgjaxx4uzfnfjPxwsBfktr' || config.url === '/g8qeeQ4pvgjaxx4uzfnfjPxwsBfktjBshvmngEhxve') {
          config.headers = Object.assign({}, config.headers || {}, {
            'qezlitjmrpl1000wfb': '2',
          });
          setTokenG(Encode.encode(flutterBaseInfo.token), Encode.encode('koljiuhiyg'));
        } else {
          setToken(flutterBaseInfo.token);
          config.headers = Object.assign({}, config.headers || {}, {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          });
        }

        console.log(config.headers, ')))))))))))111111111111');
      }
    }

    const baseInfo = JSON.parse(localStorage.getItem('BaseInfo'));
    if (baseInfo && baseInfo.token) {
      console.log(config.headers, '++++++++++++++');
      return config;
    }

    // 如果 baseInfo 还未准备好，等待直到准备好
    return new Promise((resolve) => {
      const checkToken = setInterval(() => {
        const baseInfo = JSON.parse(localStorage.getItem('BaseInfo'));
        if (baseInfo && baseInfo.token) {
          clearInterval(checkToken);
          resolve(config);
        }
      }, 100);
    });
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(function (response) {
  console.log(response.data['qezlitjmrpl1000wfb'],response, '11111')
  if (response.config.url === '/g8jojer5kttuux4qgytZxHpjlXa' || response.config.url === '/g8qeeQ4pvgjaxx4uzfnfjPxwsBfktr'  || response.config.url === '/g8qeeQ4pvgjaxx4uzfnfjPxwsBfktjBshvmngEhxve') {
    return Encode.decode(response.data['qezlitjmrpl1000wfb'])
  } else {
    if (response.data.code === 1000) {
      Toast(response.data.msg)
      setTimeout(() => {
        nativeBridgeConfig.nativeCall(localStorage.getItem("appCode") + "-4");
        // window.android.loginOut();
      }, 1500);
    }
    if (response.data.code === 9999) {
      Toast(response.data.msg)
    }
    return response.data
  }

}, function (error) {

  return Promise.reject(error)
})

export default ({ url, method = 'GET', data = {}, params = {}, headers = {} }) => {
  return axios({
    url,
    method,
    data,
    params,
    headers
  })
}
// export default axios
